import { LazyLoadImage } from 'react-lazy-load-image-component';
import React from 'react';
import appleStoreIcon from '../../images/icons/app-store.png';
import googlePlayIcon from '../../images/icons/google-play.png';
import huaweiPlayIcon from '../../images/icons/huawei_app_gallery.webp';

export default ({ appStoreLink, googlePlayLink, huaweiPlayLink }) => (
	<div className="row d-flex justify-content-center">
		{appStoreLink && (
			<div className="col-12 col-md-4 d-flex justify-content-center p-2 mt-2 mt-md-0">
				<a
					className=""
					href={appStoreLink}
					target="_blank"
					rel="noopener noreferrer"
				>
					<LazyLoadImage
						src={appleStoreIcon}
						className="img-fluid store-icon"
						alt="Apple Store"
					/>
				</a>
			</div>
		)}

		{googlePlayLink && (
			<div className="col-12 col-md-4 d-flex justify-content-center p-2 mt-2 mt-md-0">
				<a
					className=""
					href={googlePlayLink}
					target="_blank"
					rel="noopener noreferrer"
				>
					<LazyLoadImage
						src={googlePlayIcon}
						className="img-fluid store-icon"
						alt="Google Play"
					/>
				</a>
			</div>
		)}
		{huaweiPlayLink && (
			<div className="col-12 col-md-4 d-flex justify-content-center p-2 mt-2 mt-md-0">
				<a
					className=""
					href={huaweiPlayLink}
					target="_blank"
					rel="noopener noreferrer"
				>
					<LazyLoadImage
						src={huaweiPlayIcon}
						className="img-fluid store-icon"
						alt="Huawei AppGallery"
					/>
				</a>
			</div>
		)}
	</div>
);
